module.exports = __webpack_public_path__ + "static/img/bg_en.812aaa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xmasSaled-2025/bg_en.png
// module id = QRbb
// module chunks = 1